import React, { Suspense, useEffect, useState } from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import LoaderOverly from '../components/loader'
import Navbar from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import AboutUs from '../pages/about-us/About';
import Menu from '../pages/menu';
import ViewPromo from '../pages/promotions/ViewPromo';

//import Register from '../pages/administrator/register';
import Login from '../pages/administrator/login';
import Error404 from '../pages/administrator/error404';
import Upload from '../pages/administrator/Marketing/FileUpload';

const Locations = React.lazy(() => import('../pages/locations'));
const Home = React.lazy(() => import('../pages/home'));

const RouteApp = () => {
const location = useLocation();
const [isLoading, setIsLoading]=useState(true);

const [authenticated, setAuthenticated] = useState(false);
const handleLogin = () => {
setAuthenticated(true);
};

const handleLogout = () =>{
setAuthenticated(false);
};

useEffect(() =>{
    setIsLoading(true);
    const timer = setTimeout(()=> setIsLoading(false), 1000);
    return () => clearTimeout(timer);
}, [location.pathname]);

    return (
        <> {isLoading ?(
            <LoaderOverly />
        ) : (

        <Suspense fallback={<LoaderOverly />}>
            <Routes>
                <Route path='/' element={<Home />} />
                <Route path='/location/:latitude/:longitude' element={<Locations/>}/>
                <Route path="/Menu" element={<MenuPage/>}/>
                <Route path="/Promo" element={<PromoPage/>}/>
                
                {/*Route ke administrator*/}
                <Route path="/login" element={!authenticated ? <Login onLogin={handleLogin} /> : <Navigate to="/upload" />}/>
                <Route path='/error404' element={<Error404/>}/>
                <Route path="/upload" element={<Upload/>}/>
                {/* <Route path="/register" element={<Register/>}/> */}
                
                {/* <Route path="/dashboard" element={<Dashboard/>} /> */}
                {/* <Route path="/register" element={!user ? <Register onRegister={handleLogin}/>:<Navigate to="/dashboard"/>}/>
                <Route path="/dashboard" element={user ? <Dashboard user={user} onLogout={handleLogout} /> : <Navigate to="/login" />}/>
                <Route path="/administrator" element={<Navigate to={user ? "/dashboard" : "/login"} />}/>
                <Route path="/Card" element={<FlipCard/>}
        /> */}
            </Routes>
        </Suspense>
        )}
     </>
    );

    // function AboutPage(){
    //     return (
    //         <div className="App">
    //             <Navbar />
    //             <AboutUs />
    //             <Footer />
    //         </div>
    //     );
    // }

    function MenuPage(){
        return (
            <div className="App">
                <Navbar />
                <Menu />
                <Footer />
            </div>
        );
    }

    function PromoPage (){
        return (
            <div className="App">
                <Navbar />
                <ViewPromo />
                <Footer />
            </div>
        );
    }
    
}
export default RouteApp